import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';

import LanguageSelect from 'containers/ui/select/LanguageSelect';
import NotificationDropdownContainer from 'containers/notifications/NotificationDropdownContainer';

import SpogButton from 'components/ui/form/SpogButton';

import {isMobile} from 'util/utils';

import 'style/components/ui/layout/nav/header-bar.scss';

/** Component to render the header bar of the application */
class HeaderBar extends Component {

    static propTypes = {
        title:     PropTypes.string, // The title to show in the app header
        pageTitle: PropTypes.string, // The title to show in the browser header
        onToggle:  PropTypes.func, // Function to bind the toggle (on mobile only).
        onLogout:  PropTypes.func // Listener when the user does logout
    };

    renderTitle() {
        const {
            pageTitle
        } = this.props;

        const _getDeviceClass = () => isMobile() ? 'mobile' : 'desktop';
        const _getClass = () => `header-title ${_getDeviceClass()}`;

        return (
            <div className={_getClass()}>
                <h2 className="title">
                    {pageTitle}
                </h2>
            </div>
        );
    }

    renderSidebarIcon() {
        const {onToggle} = this.props;

        return (
            <div className="sidebar-icon">
                <SpogButton
                    id="toggle-sidebar"
                    icon="navicon"
                    className="menu-icon"
                    onClick={onToggle}
                />
            </div>
        );
    }

    renderSingOutButton() {
        const {onLogout, onUnimpersonate, isImpersonate, intl: {formatMessage}} = this.props;

        if (isImpersonate) {
            return (
                <div className="unimpersonalize-icon">
                    <SpogButton
                        iconRight
                        text={formatMessage({id: 'btn.returnImpersonate'})}
                        icon="arrow-right"
                        onClick={onUnimpersonate}
                    />
                </div>
            );
        }

        return (
            <div className="sing-out-icon">
                <SpogButton
                    icon="power-off"
                    iconLg
                    onClick={onLogout}
                />
            </div>
        );
    }

    renderToolbar() {

        return (
            <div className="header-toolbar">
                {this.renderSidebarIcon()}
                <NotificationDropdownContainer />
                <LanguageSelect />
                {this.renderSingOutButton()}
            </div>);
    }

    renderHeader() {
        return (
            <Col xs={12}>
                {this.renderToolbar()}
                {this.renderTitle()}
            </Col>
        );
    }

    render() {
        return (
            <Row className="header">
                {this.renderHeader()}
            </Row>
        );
    }
}

export default injectIntl(HeaderBar);



// WEBPACK FOOTER //
// ./src/components/ui/layout/nav/HeaderBar.jsx